
import { FandfFormOfPayment } from 'app/calcs/customers/fandf/interfaces'
import { SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import { getDefaultRetirementSavingsPersonInputs } from 'app/calcs/retirementSavings'
import { Profile, updateLifeExpectancy } from 'app/redux/Profile/model'
import { Gender } from 'app/redux/Profile/model/interfaces'
import * as DateCalcs from 'app/utils/DateCalcs'
import { ConfigFandf } from 'config/fandf'
import { ColumnNames } from 'config/fandf/ETL/interfaces'
import * as _ from 'lodash'
import * as moment from 'moment'

const genderMap = {
    M: Gender.male,
    F: Gender.female
}
const gm = (g: string) => genderMap[g] || Gender.unidentified

/**
 * Populates a profile with the information found in 'extraInfo'.
 *
 * @param profile - the profile to load.
 */
function loadProfilePresets(profile: Profile): Promise<Profile> {
    const ex = profile.extraInfo

    const member = profile.getHeadOfHousehold()
    member.firstName = ex[ColumnNames.memberFirstName]
    member.lastName = ex[ColumnNames.memberLastName]
    member.dob = moment.utc(ex[ColumnNames.memberDOB])
    member.gender = gm(ex[ColumnNames.memberGender])

    const beginPaymentsAge = moment.duration(65, 'years')

    profile.pension.fandf = {
        beginPaymentsAge,
        formOfPayment: FandfFormOfPayment.fiftyPercentJointAndSurvivor,
        basePay: 0,
        hireDate: moment.utc(),
        annualSalaryIncrease: 3
    }

    loadUpgradeableData(profile)

    return updateLifeExpectancy(member)
    .then(() => profile)
}

function loadMemberRetirementData(profile: Profile) {
    const ex = profile.extraInfo

    // move along, nothing to see here...
}

function loadUpgradeableData(profile: Profile) {
    const ex = profile.extraInfo

    profile.pension.fandf.basePay = ex[ColumnNames.basePay]
    profile.pension.fandf.hireDate = DateCalcs.excelSerialToMoment(ex[ColumnNames.hireDate])

    // pick up a 401k balance if the user has not entered one
    loadMemberRetirementData(profile)

    // tslint:disable-next-line:no-debugger
    //debugger
}

/**
 * Returns an array of the information in 'extraInfo' described by a column name.
 *
 * @param profile - the profile containing the 'extraInfo'
 * @param columnNames - a list of columns required
 */
function pickColumns(profile: Profile, columnNames: string[]): any[] {
    if (!profile.extraInfo) { return [] }
    return _.map(columnNames, (propName) => profile.extraInfo[propName])
}

export {
    ColumnNames,
    loadProfilePresets,
    pickColumns,
    loadUpgradeableData
}



// WEBPACK FOOTER //
// ./src/config/fandf/ETL/index.ts